import React from "react";
import {
  ClockCircleOutlined,
  SyncOutlined,
  ToolOutlined,
  BuildOutlined,
  ExperimentOutlined,
  SafetyCertificateOutlined,
  BgColorsOutlined,
  ScissorOutlined,
  InboxOutlined,
  CarOutlined,
  ThunderboltOutlined,
  FireOutlined,
  CheckCircleOutlined,
  StopOutlined,
  RocketOutlined,
  ContainerOutlined,
} from "@ant-design/icons";

// Catálogo curado (verificado contra @ant-design/icons instalado) para que cada
// etapa pueda tener su propio icono, en vez de inferirlo solo de esInicial/esFinal.
export const ICONOS_ETAPA = {
  ClockCircleOutlined,
  SyncOutlined,
  ToolOutlined,
  BuildOutlined,
  ExperimentOutlined,
  SafetyCertificateOutlined,
  BgColorsOutlined,
  ScissorOutlined,
  InboxOutlined,
  CarOutlined,
  ThunderboltOutlined,
  FireOutlined,
  CheckCircleOutlined,
  StopOutlined,
  RocketOutlined,
  ContainerOutlined,
};

export const OPCIONES_ICONO_ETAPA = Object.keys(ICONOS_ETAPA);

// Si la etapa no tiene icono/color propio (etapas creadas antes de este cambio),
// cae al criterio anterior basado en esInicial/esFinal.
export const iconoDeEtapa = (etapa) => {
  if (!etapa) return <ClockCircleOutlined />;
  if (etapa.icono && ICONOS_ETAPA[etapa.icono]) {
    const Icono = ICONOS_ETAPA[etapa.icono];
    return <Icono />;
  }
  if (etapa.esFinal) return <CheckCircleOutlined />;
  if (etapa.esInicial) return <ClockCircleOutlined />;
  return <SyncOutlined spin />;
};

export const colorDeEtapa = (etapa) => {
  if (!etapa) return "#8c8c8c";
  if (etapa.color) return etapa.color;
  if (etapa.esFinal) return "#52c41a";
  if (etapa.esInicial) return "#8c8c8c";
  return "#1890ff";
};
